<template>
  <div class="row">
    <div class="col-12">
      <b-card header="Website User" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
        <div class="row">
          <div class="col-12" v-if="!notEmptyObject(website_user)">
            <h5 class="red_color">NO USER FOUND</h5>
            <p class="pt-0 mb-2">{{worker.person.first_name}} {{worker.person.surname}} worker has not created an account on our website.<br><br>
              Unless they do so or unless we have other documentation to prove otherwise we do not have proof of agreement to:
            </p>
          </div>
          <div class="col-12" v-else>
            <h5 class="green_color">User Found</h5>
            <p class="pt-0 mb-2">This worker has created an account on our website.</p>
              <p class="pt-0 mb-2 ml-2">
                <strong style="display: inline-block; width: 150px;">User Verified at:</strong> {{website_user.email_verified_at | formatDateTime}}<br>
                <strong style="display: inline-block; width: 150px;">Latest Login:</strong> {{website_user.last_login | formatDateTime}}
              </p>
            <p class="pt-0 mb-2">By doing so {{worker.person.first_name}} {{worker.person.surname}} agreed to the following on {{website_user.created_at | formatDateTime}}:</p>
          </div>
          <div class="col-12">
            <ul  v-if="crmType === 'payroll'">
              <li>Contract for Services</li>
              <li>Data Protection & Privacy</li>
              <li>Conduct Regulations Opt Out Notice</li>
              <li>Sexual Harassment Policy</li>
            </ul>
            <ul  v-if="crmType === 'recruitment'">
              <li>Contract for Services (PAYE &amp; CIS/Limited)</li>
              <li>Equal Opportunities Policy</li>
              <li>Data Protection Policy</li>
              <li>Eligibility to work in the UK</li>
              <li>Sexual Harassment Policy</li>
            </ul>
          </div>
        </div>
      </b-card>
    </div>
    <div class="col-12" v-if="worker.rel_services.recruitment">
      <b-card header="Recruitment Declarations" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
        <div class="row">
          <div class="col-12">
            <p class="pt-0 mb-2">The following declarations have been made by the worker regarding their right to work.</p>
            <h5 class="pt-0 mb-2 font-weight-bold">Criminal Convictions</h5>
            <p class="pt-0 mb-3 ml-2">
              <strong style="display: inline-block; width: 350px;">Any Criminal Convictions:</strong>
              <span v-if="worker.rel_recruitment_info.any_criminal_convictions">Yes</span>
              <span v-else>No</span><br>
              <strong style="display: inline-block; width: 350px;"
              v-if="worker.rel_recruitment_info.any_criminal_convictions">Details:</strong> <span v-if="worker.rel_recruitment_info.any_criminal_convictions">{{worker
                .rel_recruitment_info.criminal_convictions_details}}</span>
            </p>
          </div>
        </div>
      </b-card>
    </div>
    <div class="col-12">
      <b-card header="Contract File" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
        <div class="row">
          <div class="col-12" v-if="contract_file.length === 0">
            <h5 class="red_color">No Contract Uploaded</h5>
            <p class="pt-0 mb-2">There is no uploaded contract file found for this worker.</p>
          </div>
          <div class="col-12" v-else>
            <div class="row">
              <div class="col-12 files_uploaded" v-for="file in contract_file">
                <div class="row">
                  <div class="col-lg-6">
                    <button @click="view_file_modal(file.id)" class="btn orcaBtn greenBtn sm_btn" data-toggle="tooltip" title="View Worker File"><i class="fas fa-eye"></i>&nbsp;
                      View
                    </button>
                    <span class="id_type">{{ file.type.file_type }}</span>
                  </div>
                  <div class="col-lg-6 pt-1">
                    <i>Uploaded By:</i> &nbsp;&nbsp;
                    <span v-if="file.file_log_by !== null && file.file_logs !== null && file.file_logs.log_by_type === 'App\\Models\\Users\\User'" class="note_user_created_at">
                      {{ file.file_log_by.first_name }} {{ file.file_log_by.surname }} - {{ file.updated_at | formatDateTime }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "declarations",
  props: ['worker', 'files'],
  data() {
    return {
      website_user: {}
    }
  },
  beforeMount() {
    axios.get(this.crmApiPath + 'worker/website/user_info/' + this.worker.id).then(res => {
      if (typeof res.data !== 'string') {
        this.website_user = res.data;
      }
    })
  },
  computed: {
    contract_file() {
      if (this.files.length > 0) {
        return this.files.filter(ft => ft.file_master_type_id === 8)
      } else {
        return [];
      }
    }
  },
  methods: {
    view_file_modal(file_id) {
      this.$store.commit('SHOW_VIEW_FILE_MODAL', {
        id: file_id,
        type: 'worker'
      });
      this.$store.state.files.view_modal = true;
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'view_file_modal'));
    },
  }
}
</script>

<style scoped lang="scss">
.files_uploaded {
  padding-left:  30px;
  margin-bottom: 15px;

  button {
    display:      inline-block;
    width:        auto;
    margin-right: 20px;
  }

  .id_type {
    font-weight: bold;
    display:     inline-block;
    width:       200px;
  }
}
</style>
